import { render, staticRenderFns } from "./MovixLink.vue?vue&type=template&id=5f398c04"
import script from "./MovixLink.vue?vue&type=script&lang=js"
export * from "./MovixLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f398c04')) {
      api.createRecord('5f398c04', component.options)
    } else {
      api.reload('5f398c04', component.options)
    }
    module.hot.accept("./MovixLink.vue?vue&type=template&id=5f398c04", function () {
      api.rerender('5f398c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/MovixLink.vue"
export default component.exports